export const DefaultFieldsToSubmit: string[] = [
  "pan",
  "expirydate",
  "securitycode",
];
